const variables = [
    'fgColor',
    'fgColorAlt',
    'bgColor',
    'bgColorAlt',
    'accentColor',
    'accentColorAlt',
    'accentColor2',
    'siteWidth',
    'sitePadding',
    'sectionMargin',
    'buttonBgColor',
    'buttonBorderColor',
    'buttonColor',
];
function cssVar(name) {
    return `var(--${name})`;
}
function setCssVar(name, value) {
    return `--${name}: ${value}`;
}
export { cssVar, setCssVar };
